import styled from "styled-components";

export const PageContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  padding: 40px;
  box-sizing: border-box;
  background-image: url("/textura.jpg");
  background-size: cover;
  background-attachment: fixed;
`;

export const ContentBox = styled.div`
  background: rgba(30, 30, 30, 0.9);
  backdrop-filter: blur(10px);
  border-radius: 8px;
  padding: 30px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  margin-bottom: 20px;
`;

export const Header = styled.div`
  margin-bottom: 30px;
  h2 {
    color: #e6aa3a;
    font-size: 28px;
    margin: 0;
  }
`;

export const SummaryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 15px;
  margin-bottom: 30px;
`;

export const SummaryCard = styled.div`
  background: rgba(255, 255, 255, 0.05);
  padding: 15px;
  border-radius: 8px;
  border-left: 5px solid ${(props) => props.borderColor || "#e6aa3a"};

  small {
    color: #aaa;
    font-size: 11px;
    text-transform: uppercase;
    display: block;
    margin-bottom: 5px;
    line-height: 1.2;
  }

  h3 {
    color: #fff;
    margin: 0;
    font-size: 18px;
  }
`;

export const ActionButton = styled.button`
  background: #e6aa3a;
  color: #111;
  border: none;
  border-radius: 6px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
  &:hover {
    background: #ffc300;
    transform: translateY(-2px);
  }
  &:disabled {
    background: #888;
    cursor: not-allowed;
    transform: none;
  }
`;

export const SearchSection = styled.div`
  margin-bottom: 30px;
  position: relative;
  max-width: 600px;
`;

export const SearchBar = styled.div`
  display: flex;
  input {
    flex-grow: 1;
    height: 45px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    background: rgba(0, 0, 0, 0.3);
    padding: 0 20px;
    color: #fff;
    border-radius: 6px 0 0 6px;
    &:focus {
      outline: none;
      border-color: #e6aa3a;
    }
  }
  button {
    width: 60px;
    background: #e6aa3a;
    border: none;
    color: #111;
    border-radius: 0 6px 6px 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    &:disabled {
      background: #888;
      cursor: not-allowed;
    }
  }
`;

export const ResultsDropdown = styled.div`
  position: absolute;
  top: 50px;
  left: 0;
  width: 100%;
  background: #2c2c2c;
  border: 1px solid #e6aa3a;
  z-index: 10;
  max-height: 300px;
  overflow-y: auto;
  border-radius: 0 0 8px 8px;
`;

export const ResultItem = styled.div`
  padding: 12px 20px;
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  &:hover {
    background: rgba(230, 170, 58, 0.2);
  }
`;

export const ClientHeader = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  padding: 20px;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  margin-bottom: 20px;
  border-left: 4px solid #e6aa3a;
  div p {
    margin: 5px 0;
    color: #fff;
    font-size: 14px;
  }
  strong {
    color: #e6aa3a;
  }
`;

export const FilterGrid = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  flex-wrap: wrap;
  align-items: flex-end;
  .group {
    display: flex;
    flex-direction: column;
    gap: 5px;
    label {
      color: #e6aa3a;
      font-size: 12px;
      font-weight: bold;
    }
  }
  input,
  select {
    background: rgba(0, 0, 0, 0.5);
    border: 1px solid rgba(255, 255, 255, 0.2);
    color: #fff;
    padding: 8px 12px;
    border-radius: 4px;
    height: 40px;
    &:focus {
      outline: none;
      border-color: #e6aa3a;
    }
  }
`;

export const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  th,
  td {
    padding: 12px;
    text-align: left;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    color: #fff;
    font-size: 13px;
    cursor: pointer;
  }
  thead tr {
    border-bottom: 2px solid #e6aa3a;
  }
  .profit {
    color: #4caf50;
    font-weight: bold;
  }
`;

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  gap: 15px;
  color: #fff;
`;

export const PaginationButton = styled.button`
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.2);
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
  &:hover:not(:disabled) {
    background: #e6aa3a;
    color: #111;
  }
`;
